<template>
  <v-container fluid pt-0 v-if="loaded">
    <v-dialog max-width="400" persistent v-model="oldEventLoadDialog.show">
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <Dropdown
                  :ajax="true"
                  :data="'events/' + this.event.id"
                  :label="$t('fields.event')"
                  v-model="oldEventLoadDialog.event_id"
                ></Dropdown>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="oldEventLoadDialogClose" color="error">{{
            $t('buttons.cancel')
          }}</v-btn>
          <v-btn @click="oldEventLoadDialogSave" color="success">{{
            $t('buttons.ok')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row wrap justify-center>
      <v-flex xl8 lg10>
        <v-layout row wrap>
          <v-flex pt-4 xs12>
            <v-layout row wrap>
              <v-flex>
                <span class="display-1 primary--text">{{ moduleTitle }}</span>
              </v-flex>
              <v-spacer />
              <div>
                <span
                  v-if="event.status == 'active' || event.status == 'completed'"
                >
                  <b>{{ formatDate(event.start) }}</b>
                  <b v-if="event.status == 'completed'"
                    >- {{ formatDate(event.end) }}</b
                  >
                  <b class="success--text" v-if="event.status == 'active'">
                    <span @click="showOnlineVoters" style="cursor: pointer"
                      >&nbsp;(Online: {{ voters_online }})</span
                    ></b
                  >
                </span>
                <v-btn
                  icon
                  flat
                  outline
                  color="success"
                  @click="start(event)"
                  v-if="event.status == 'published'"
                >
                  <v-icon>fa-play-circle</v-icon>
                </v-btn>
                <v-btn
                  icon
                  flat
                  outline
                  color="error"
                  @click="stop(event)"
                  v-if="event.status == 'active'"
                >
                  <v-icon>fa-stop-circle</v-icon>
                </v-btn>
                <v-btn
                  icon
                  flat
                  outline
                  color="info"
                  @click="refreshEvent"
                  v-if="event.status != 'draft'"
                >
                  <v-icon small>fa-sync</v-icon>
                  <!-- {{$t('buttons.refresh')}} -->
                </v-btn>

                <v-btn
                  v-if="event.status === 'completed'"
                  @click="getPdf(event)"
                  icon
                  flat
                  outline
                  color="info"
                >
                  <v-icon small>fa-file-pdf</v-icon>
                </v-btn>

                <v-btn
                  icon
                  flat
                  outline
                  color="info"
                  v-if="event.status == 'active' && meetingSession !== null"
                  @click="muteUnmute"
                >
                  <v-icon small v-if="microphoneMuted"
                    >fa-microphone-slash</v-icon
                  >
                  <v-icon small v-else>fa-microphone</v-icon>
                </v-btn>
                <span
                  v-if="event.status == 'active' && meetingSession !== null"
                >
                  <v-badge
                    v-if="numberOfScreensShared > 0"
                    overlap
                    color="info"
                  >
                    <template v-slot:badge>
                      <v-icon dark small>
                        {{ numberOfScreensShared }}
                      </v-icon>
                    </template>
                    <v-btn
                      icon
                      flat
                      outline
                      :disabled="screenSharingLimitReached"
                      :color="screenSharingStarted ? 'error' : 'info'"
                      v-if="event.status == 'active'"
                      @click="
                        screenSharingStarted
                          ? stopScreenSharing()
                          : startScreenSharing()
                      "
                      class="mr-0 mt-0 mb-0"
                    >
                      <v-icon small>fa-desktop</v-icon>
                    </v-btn>
                  </v-badge>
                  <span v-else>
                    <v-btn
                      icon
                      flat
                      outline
                      :color="screenSharingStarted ? 'error' : 'info'"
                      v-if="event.status == 'active'"
                      @click="
                        screenSharingStarted
                          ? stopScreenSharing()
                          : startScreenSharing()
                      "
                      class="mr-0 mt-0 mb-0"
                    >
                      <v-icon small>fa-desktop</v-icon>
                    </v-btn>
                  </span>
                </span>
              </div>
            </v-layout>
          </v-flex>
          <v-flex pt-4 xs12>
            <v-card class="event-main-card" elevation="0">
              <v-tabs
                class="main-event-tabs"
                grow
                slider-color="#6F6F6F"
                v-model="activeTab"
              >
                <v-tab
                  v-for="(visibleNavTab, key, index) in visibleNavTabs"
                  v-bind:key="index"
                >
                  <v-icon small>{{ visibleNavTab.icon }} fa-fw</v-icon>&nbsp;{{
                    visibleNavTab.label
                  }}
                  <span v-if="visibleNavTab.id === TAB_ID_COMMUNICATION">
                    <v-icon
                      class="ml-2"
                      small
                      style="color: orange !important"
                      v-if="new_message_indicator === true"
                    >
                      far fa-dot-circle
                    </v-icon>
                  </span>
                  <span v-else>
                    <v-icon
                      class="ml-2 error-icon"
                      small
                      v-if="checkTabError(visibleNavTab.errorIdentifier)"
                    >
                      fa-exclamation-circle
                    </v-icon>
                  </span>
                </v-tab>
              </v-tabs>

              <component
                v-if="currentTabComponent !== undefined"
                :is="currentTabComponent.component"
                v-bind="currentTabComponent.propsData"
                v-on="currentTabComponent.events"
                class="pt-3"
              ></component>

              <v-layout justify-center row wrap>
                <v-tooltip bottom>
                  <v-btn
                    @click="$router.go(-1)"
                    class="font-weight-bold"
                    color="error"
                    slot="activator"
                  >
                    {{ $t('buttons.back') }}
                  </v-btn>
                  <span>{{ $t('tooltips.back') }}</span>
                </v-tooltip>
                <v-tooltip bottom v-if="event.id == 0 && activeTab != maxTab">
                  <v-btn
                    @click="eventSaveClick"
                    class="font-weight-bold"
                    color="info"
                    slot="activator"
                  >
                    {{ $t('buttons.saveDraft') }}
                  </v-btn>
                  <span>{{ $t('tooltips.saveDraft') }}</span>
                </v-tooltip>
                <v-tooltip
                  bottom
                  v-if="
                    event.status == 'draft' &&
                    (event.id != 0 || activeTab == maxTab)
                  "
                >
                  <v-btn
                    @click="eventSaveClick"
                    class="font-weight-bold"
                    color="info"
                    slot="activator"
                  >
                    {{ $t('buttons.save') }}
                  </v-btn>
                  <span>{{ $t('tooltips.save') }}</span>
                </v-tooltip>
                <v-tooltip bottom v-if="activeTab != maxTab">
                  <v-btn
                    @click="activeTab++"
                    class="font-weight-bold"
                    color="primary"
                    slot="activator"
                  >
                    {{ $t('buttons.nextStep') }}
                  </v-btn>
                  <span>{{ $t('tooltips.nextStep') }}</span>
                </v-tooltip>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-dialog max-width="600" persistent v-model="displayOnlineVotersList">
      <v-card>
        <v-card-title
          ><span class="title">Online Voters List</span></v-card-title
        >
        <v-card-text>
          <span
            v-for="onlineVoter in event.voters_online_list"
            :key="onlineVoter"
            >{{ onlineVoter }}<br
          /></span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.stop="closeOnlineVotersList" color="error">{{
            $t('buttons.close')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Dropdown from '@/components/trinkets/Dropdown.vue'
import EventTabPublish from '@/components/EventTabPublish.vue'
import EventTabGeneralInformation from '@/components/EventTabGeneralInformation.vue'
import EventTabInvitations from '@/components/EventTabInvitations.vue'
import EventTabVoters from '@/components/EventTabVoters.vue'
import EventTabCommunication from '@/components/EventTabCommunication.vue'
import EventTabQuestionsAndStatistics from '@/components/EventTabQuestionsAndStatistics.vue'
import EventTabDocuments from '@/components/EventTabDocuments.vue'
import EventTabAgenda from '@/components/EventTabAgenda.vue'
import { v4 as uuidv4 } from 'uuid'

import Answer from '@/models/Answer.js'
import Question from '@/models/Question.js'
import Logo from '@/models/Logo.js'
import Document from '@/models/Document.js'
import Message from '@/models/Message.js'
import Voter from '@/models/Voter.js'
import Authorizer from '@/models/Authorizer.js'

import moment from 'moment'
import {
  ConsoleLogger,
  DefaultDeviceController,
  DefaultMeetingSession,
  LogLevel,
  MeetingSessionConfiguration,
} from 'amazon-chime-sdk-js'

import handle_session_error from '@/helpers/handle_session_error.js'
import handle_bad_request_error from '@/helpers/handle_bad_request_error.js'

let amazonChimeLogLevel = LogLevel.OFF

if (process.env.NODE_ENV !== 'production') {
  amazonChimeLogLevel = LogLevel.INFO
}

const TAB_ID_GENERAL = 'general'
const TAB_ID_INVITATIONS = 'invitations'
const TAB_ID_PARTICIPANTS = 'participants'
const TAB_ID_COMMUNICATION = 'communication'
const TAB_ID_ELECTIONS = 'elections'
const TAB_ID_DOCUMENTS = 'documents'
const TAB_ID_AGENDA = 'agenda'
const TAB_ID_PUBLISH = 'publish'

const VOTER_UI_TYPE_BASIC = 'basic'
const VOTER_UI_TYPE_ADVANCED = 'advanced'

export default {
  name: 'Event',

  components: {
    Dropdown,
    EventTabPublish,
    EventTabGeneralInformation,
    EventTabInvitations,
    EventTabVoters,
    EventTabCommunication,
    EventTabQuestionsAndStatistics,
    EventTabDocuments,
    EventTabAgenda,
  },

  props: ['id', 'clone'],

  data() {
    return {
      screenSharingStarted: false,
      numberOfScreensShared: 0,
      meetingSession: null,
      pusher_channels_bounded: false,
      new_message_indicator: false,
      publicPath: process.env.BASE_URL,
      moduleTitle: '',
      loaded: false,
      activeTab: 0,
      editable: true,
      justSaved: false,
      originalStatus: 'draft',
      voters_online: 0,
      voters_online_list: [],
      event: {
        enable_audio_video: false,
        voter_ui_type: VOTER_UI_TYPE_BASIC,
        anonymous: true,
        quorum: false,
        quorum_value: null,
        voters_online: 0,
        voters_online_list: [],
        logo: null,
        documents: [],
        messages: [],
        agenda: '',
        warmup_message: '',
        enable_live_questions: false,
        live_questions_visibility: 'organizer_and_voters',
        id: 0,
        type: 'classic',
        name: '',
        start: {
          date: null,
          time: '12:00',
        },
        end: {
          date: null,
          time: '12:00',
        },
        questions: [],
        header: '',
        footer: '',
        title: '',
        status: 'draft',
        intro_mail: '',
        intro_mail_title: '',
        help_contact: '',
        results: {
          totals: {
            initial_email_sent: 0,
            vote_link_opened: 0,
            sms_sent: 0,
            pin_checkedtest_true: 0,
            pin_checked_false: 0,
            voted: 0,
          },
          votes: [],
        },
        status_label: '',
        start_label: '',
        end_label: '',
        paged: false,
        sms_authentication: false,
        tags: [],
        voters: [],
        reminder_mail:
          'Poštovani,\n\nI dalje traje elektroničko glasanje za ...\nGlasanje se provodi putem aplikacije kojoj ćete pristupiti preko poveznice (linka) u ovoj poruci.',
        reminder_mail_title: 'FairVotes - Podsjetnik na on-line glasovanje',
        manual_reminders: false,
        automatic_reminders: 1,
        adding_voters_in_progress: false,
        results_in_progress: false,
        automatic_reminders_term: false,
        max_emails: 0,
        max_sms: 0,
        language: this.$i18n.locale,
        domains: [],
        allow_all_domains: true,
        allow_unsubscriptions: true,
        pdf: false,
      },
      oldEventLoadDialog: {
        show: false,
        destination: null,
        event_id: null,
      },
      charts: [],
      introAfter: '',
      translations: {},
      numberOfOtherEvents: 0,
      errorTabs: [],
      errorFields: [],
      errorMessaging: [],
      autoGrowHack: 1,
      voterSendEmailLock: false,
      weightConfig: {
        locale: 'de',
        prefix: '',
        suffix: '',
        precision: 2,
        'auto-decimal-mode': false,
        allowBlank: false,
        min: Number.MIN_SAFE_INTEGER,
        max: Number.MAX_SAFE_INTEGER,
      },
      displayOnlineVotersList: false,
    }
  },

  watch: {
    'event.sms_authentication': {
      handler: function () {
        this.updateLanguageStrings()
      },
      deep: true,
    },

    'event.language': {
      handler: function () {
        this.updateLanguageStrings()
      },
      deep: true,
    },

    'event.allow_all_domains': {
      handler: function () {
        if (this.loaded) {
          this.$nextTick(() => {
            if (this.event.allow_all_domains) {
              this.event.domains = []
            } else {
              let domains = []
              for (let i in this.event.voters) {
                let emailArray = this.event.voters[i].email.split('@')
                let emailDomain = emailArray[emailArray.length - 1]
                if (domains.indexOf(emailDomain) == -1) {
                  domains.push(emailDomain)
                }
                this.event.domains = domains
              }
            }
          })
        }
      },
      deep: true,
    },

    'event.domains': {
      handler: function (newVal, oldVal) {
        if (this.loaded) {
          if (!this.checkDomains()) {
            this.$alert(this.$t('alerts.domainsError'))
            this.$nextTick(() => {
              this.event.domains = oldVal
            })
          }
        }
      },
      deep: true,
    },
  },

  created() {
    this.TAB_ID_GENERAL = TAB_ID_GENERAL
    this.TAB_ID_INVITATIONS = TAB_ID_INVITATIONS
    this.TAB_ID_PARTICIPANTS = TAB_ID_PARTICIPANTS
    this.TAB_ID_COMMUNICATION = TAB_ID_COMMUNICATION
    this.TAB_ID_ELECTIONS = TAB_ID_ELECTIONS
    this.TAB_ID_DOCUMENTS = TAB_ID_DOCUMENTS
    this.TAB_ID_AGENDA = TAB_ID_AGENDA
    this.TAB_ID_PUBLISH = TAB_ID_PUBLISH
  },

  computed: {
    navTabs: function () {
      return [
        {
          id: TAB_ID_GENERAL,
          component: 'EventTabGeneralInformation',
          propsData: {
            editable: this.editable,
            event: this.event,
            checkFieldError: this.checkFieldError,
            isBasicUiType: this.isBasicUiType,
          },
          events: {},
          icon: 'fa-sliders-h',
          label: this.$t('tabs.general'),
          errorIdentifier: 'general',
        },
        {
          id: TAB_ID_INVITATIONS,
          component: 'EventTabInvitations',
          propsData: {
            editable: this.editable,
            event: this.event,
            introAfter: this.introAfter,
            checkFieldError: this.checkFieldError,
          },
          events: {},
          icon: 'fa-envelope',
          label: this.$t('tabs.messages'),
          errorIdentifier: 'messages',
        },
        {
          id: TAB_ID_PARTICIPANTS,
          component: 'EventTabVoters',
          propsData: {
            event: this.event,
            numberOfOtherEvents: this.numberOfOtherEvents,
            publicPath: this.publicPath,
            checkEmailDomain: this.checkEmailDomain,
          },
          events: {
            'event-save': this.eventSave,
            'load-event': this.loadEvent,
            'old-event-load-dialog-reset': this.oldEventLoadDialogReset,
            'old-event-load-dialog-show': this.toggleLoadOldEventDialog,
          },
          icon: 'fa-users',
          label: this.$t('tabs.ballot'),
          errorIdentifier: 'ballot',
        },
        {
          id: TAB_ID_COMMUNICATION,
          component: 'EventTabCommunication',
          propsData: {
            event: this.event,
          },
          events: {
            'new-message': this.handleNewMessage,
            'all-messages-seen': this.turnOffNewMessageIndicator,
          },
          icon: 'fa-envelope',
          label: this.$t('tabs.communication'),
          errorIdentifier: null,
        },
        {
          id: TAB_ID_ELECTIONS,
          component: 'EventTabQuestionsAndStatistics',
          propsData: {
            editable: this.editable,
            event: this.event,
            numberOfOtherEvents: this.numberOfOtherEvents,
          },
          events: {
            'old-event-load-dialog-reset': this.oldEventLoadDialogReset,
            'old-event-load-dialog-show': this.toggleLoadOldEventDialog,
          },
          icon: 'fa-poll',
          label: this.$t('tabs.voters'),
          errorIdentifier: 'voters',
        },
        {
          id: TAB_ID_DOCUMENTS,
          component: 'EventTabDocuments',
          propsData: {
            editable: this.editable,
            event: this.event,
          },
          events: {},
          icon: 'fa-file',
          label: this.$t('tabs.options'),
          errorIdentifier: 'options',
        },
        {
          id: TAB_ID_AGENDA,
          component: 'EventTabAgenda',
          propsData: {
            editable: this.editable,
            event: this.event,
          },
          events: {},
          icon: 'fa-list',
          label: this.$t('tabs.test'),
          errorIdentifier: 'test',
        },
        {
          id: TAB_ID_PUBLISH,
          component: 'EventTabPublish',
          propsData: {
            event: this.event,
          },
          events: {
            'event-save': this.eventSave,
          },
          icon: 'fa-play',
          label: this.$t('tabs.publish'),
          errorIdentifier: 'publish',
        },
      ]
    },

    currentTabComponent: function () {
      return this.visibleNavTabs[this.activeTab]
    },

    visibleNavTabs: function () {
      return this.navTabs.filter(tab => {
        if (this.isBasicUiType) {
          switch (tab.id) {
            case TAB_ID_COMMUNICATION:
              return false
            case TAB_ID_DOCUMENTS:
              return false
            case TAB_ID_AGENDA:
              return false
          }
        }

        // Hides communication tab when event live questions are disabled.
        if (
          tab.id === TAB_ID_COMMUNICATION &&
          this.event.enable_live_questions === false
        ) {
          return false
        }

        // Hides publish tab when event is published.
        if (tab.id === TAB_ID_PUBLISH && this.event.status != 'draft') {
          return false
        }

        return true
      })
    },

    isBasicUiType: function () {
      return this.event.voter_ui_type === VOTER_UI_TYPE_BASIC
    },

    screenSharingLimitReached() {
      // The user needs to be able to stop his screen share.
      if (this.screenSharingStarted === true) {
        return false
      }

      return this.numberOfScreensShared === 2
    },

    maxTab() {
      return this.visibleNavTabs.length - 1
    },

    microphoneMuted: function () {
      if (this.meetingSession === null) {
        return true
      }

      return this.meetingSession.audioVideo.realtimeIsLocalAudioMuted()
    },
  },

  destroyed() {
    this.$store.state.pusherInstance.unsubscribe(
      `private-encrypted-event_${this.event.id}_presence`
    )

    this.$store.state.pusherInstance.unsubscribe(
      `private-encrypted-event_${this.event.id}_presence_list`
    )

    this.$store.state.pusherInstance.unsubscribe(
      `private-encrypted-event_${this.event.id}_events`
    )

    this.$store.state.pusherInstance.connection.unbind(
      'connected',
      this.loadEvent
    )

    this.stopMeetingSession()
  },

  methods: {
    getPdf(event) {
      this.$APICall(
        'get',
        'EVENTS',
        `/${event.id}/pdf`,
        {},
        data => {
          window.open(data.pdf_link)
        },
        true,
        error => {
          handle_session_error(error, this.$store, this.$router, this.$prompt)
        }
      )
    },

    turnOffNewMessageIndicator() {
      this.new_message_indicator = false
    },

    toggleLoadOldEventDialog(event) {
      this.oldEventLoadDialog.show = event
    },

    async stopMeetingSession() {
      if (this.meetingSession === null) {
        return
      }

      this.meetingSession.audioVideo.removeContentShareObserver(
        this.meetingObserver()
      )
      this.meetingSession.audioVideo.removeObserver(this.meetingObserver())

      await this.meetingSession.audioVideo.stopContentShare()
      await this.meetingSession.audioVideo.stop()
    },

    muteUnmute() {
      const muted = this.meetingSession.audioVideo.realtimeIsLocalAudioMuted()

      if (muted) {
        this.meetingSession.audioVideo.realtimeUnmuteLocalAudio()
      } else {
        this.meetingSession.audioVideo.realtimeMuteLocalAudio()
      }
    },

    bindPusherChannels() {
      if (this.pusher_channels_bounded === true) {
        return
      }

      // When Pusher has connected, load event.
      this.$store.state.pusherInstance.connection.bind(
        'connected',
        this.loadEvent
      )

      let pusherChannel_presence = this.$store.state.pusherInstance.subscribe(
        `private-encrypted-event_${this.event.id}_presence`
      )

      let pusherChannel_presence_list = this.$store.state.pusherInstance.subscribe(
        `private-encrypted-event_${this.event.id}_presence_list`
      )

      pusherChannel_presence.bind('update', voters_online => {
        this.voters_online = voters_online
      })

      pusherChannel_presence_list.bind('update', voters_online_list => {
        this.voters_online_list = voters_online_list
      })

      let pusherChannel_events = this.$store.state.pusherInstance.subscribe(
        `private-encrypted-event_${this.event.id}_events`
      )

      pusherChannel_events.bind('stop', () => {
        this.loadEvent(true)
      })

      this.pusher_channels_bounded = true
    },

    handleNewMessage() {
      if (this.visibleNavTabs[this.activeTab].id !== TAB_ID_COMMUNICATION) {
        this.new_message_indicator = true
      }
    },

    formatDate(value) {
      return moment(`${value.date} ${value.time}`).format('DD.MM.YYYY HH:mm')
    },

    start(event) {
      this.$verify(this.$t('alerts.startEvent'), result => {
        if (result) {
          let payload = {
            sms_authentication: event.sms_authentication,
            number_of_voters: event.voterCount,
          }
          this.$APICall(
            'post',
            'EVENTS',
            '/check-tokens',
            payload,
            data => {
              if (data.success) {
                this.$APICall(
                  'get',
                  'EVENTS',
                  '/' + event.id + '/start',
                  [],
                  () => {
                    this.refreshEvent()
                  },
                  true,
                  error => {
                    handle_bad_request_error(error, this.$verify, this.$i18n)
                    handle_session_error(
                      error,
                      this.$store,
                      this.$router,
                      this.$prompt
                    )
                  }
                )
              } else {
                this.$alert(this.$t('alerts.tokensNotAvailable'))
              }
            },
            true,
            error => {
              handle_session_error(
                error,
                this.$store,
                this.$router,
                this.$prompt
              )
            }
          )
        }
      })
    },

    stop(event) {
      this.$verify(this.$t('alerts.stopEvent'), result => {
        if (result) {
          this.$APICall(
            'get',
            'EVENTS',
            '/' + event.id + '/stop',
            [],
            () => {
              this.refreshEvent()
            },
            true,
            error => {
              handle_bad_request_error(error, this.$verify, this.$i18n)
              handle_session_error(
                error,
                this.$store,
                this.$router,
                this.$prompt
              )
            }
          )
        }
      })
    },

    refreshEvent() {
      this.loadEvent(true)
    },

    checkDomains() {
      for (let i in this.event.voters) {
        if (!this.checkEmailDomain(this.event.voters[i].email)) {
          return false
        }
      }
      return true
    },

    eventSave(back, resendVoter, publish, loader = false) {
      let message = ''
      this.errorTabs = []
      this.errorFields = []
      if (this.event.name.trim() == '') {
        message += this.$t('alerts.nameMissing') + '<br />'
        this.errorTabs.push('general')
        this.errorFields.push('name')
      } else if (this.event.name.length > 300) {
        message += this.$t('alerts.nameTooLong') + '<br />'
        this.errorFields.push('name')
        this.errorTabs.push('general')
      }

      if (this.event.manual_reminders === true) {
        if (this.event.reminder_mail_title == null) {
          message += this.$t('alerts.reminderMailTitleMissing') + '<br />'
          this.errorTabs.push('general')
          this.errorFields.push('reminder_mail_title')
        } else if (this.event.reminder_mail_title.trim() == '') {
          message += this.$t('alerts.reminderMailTitleMissing') + '<br />'
          this.errorTabs.push('general')
          this.errorFields.push('reminder_mail_title')
        } else if (this.event.reminder_mail_title.length > 50) {
          message += this.$t('alerts.reminderTitleTooLong') + '<br />'
          this.errorTabs.push('general')
          this.errorFields.push('reminder_mail_title')
        }
        if (this.event.reminder_mail == null) {
          message += this.$t('alerts.reminderMailMissing') + '<br />'
          this.errorTabs.push('general')
          this.errorFields.push('reminder_mail')
        } else if (this.event.reminder_mail.trim() == '') {
          message += this.$t('alerts.reminderMailMissing') + '<br />'
          this.errorTabs.push('general')
          this.errorFields.push('reminder_mail')
        }
      }

      if (this.event.quorum === true) {
        if (this.event.quorum_value == null) {
          message += this.$t('alerts.quorumValueEmpty') + '<br />'
          this.errorTabs.push('general')
          this.errorFields.push('quorum_value')
        } else if (this.event.quorum_value.trim() == '') {
          message += this.$t('alerts.quorumValueEmpty') + '<br />'
          this.errorTabs.push('general')
          this.errorFields.push('quorum_value')
        } else if (!Number.isInteger(Number(this.event.quorum_value))) {
          message += this.$t('alerts.quorumValueNotInteger') + '<br />'
          this.errorTabs.push('general')
          this.errorFields.push('quorum_value')
        } else if (this.event.quorum_value < 1) {
          message += this.$t('alerts.quorumValueMin') + '<br />'
          this.errorTabs.push('general')
          this.errorFields.push('quorum_value')
        }
      }

      if (this.event.status != 'draft' || publish) {
        if (this.event.voters.length == 0) {
          this.errorTabs.push('ballot')
          message += this.$t('alerts.noVoters') + '<br />'
        }
        if (this.event.help_contact.trim() == '') {
          message += this.$t('alerts.helpContactMissing') + '<br />'
          this.errorTabs.push('messages')
          this.errorFields.push('help_contact')
          this.errorMessaging.push('support')
        } else if (!this.$checkEmail(this.event.help_contact)) {
          message += this.$t('alerts.helpContactFormat') + '<br />'
          this.errorTabs.push('messages')
          this.errorFields.push('help_contact')
          this.errorMessaging.push('support')
        }
        if (this.event.intro_mail_title.trim() == '') {
          this.errorTabs.push('messages')
          this.errorFields.push('intro_mail_title')
          this.errorMessaging.push('invitation')
          message += this.$t('alerts.introMailTitleMissing') + '<br />'
        } else if (this.event.intro_mail_title.length > 180) {
          this.errorTabs.push('messages')
          this.errorFields.push('intro_mail_title')
          this.errorMessaging.push('invitation')
          message += this.$t('alerts.introMailTitleTooLong') + '<br />'
        }
        if (this.event.intro_mail.trim() == '') {
          this.errorTabs.push('messages')
          this.errorFields.push('intro_mail')
          this.errorMessaging.push('invitation')
          message += this.$t('alerts.introMailMissing') + '<br />'
        }

        if (
          this.event.automatic_reminders_term &&
          this.event.automatic_reminders == 0
        ) {
          this.errorTabs.push('options')
          message += this.$t('alerts.automaticReminderZero') + '<br />'
        }

        if (this.event.questions.length == 0) {
          this.errorTabs.push('voters')
          message += this.$t('alerts.questionsMissing') + '<br />'
        }
        let questionEmptyMessage = ''
        let questionMessage = ''
        let answerMessage = ''
        let answerEmptyMessage = ''
        let hasEnoughAnswersMessage = ''
        let answerLimitMessageMax = ''
        let answerLimitMessageMin = ''
        let answerMaxZero = ''
        let answerMinZero = ''
        for (let questionIndex in this.event.questions) {
          let question = this.event.questions[questionIndex]
          if (question.question.trim() == '') {
            this.errorTabs.push('voters')
            questionEmptyMessage = this.$t('alerts.questionEmpty') + '<br />'
          }
          let numberOfAnswers = 0
          for (let answerIndex in question.answers) {
            let answer = question.answers[answerIndex]
            if (answer.label.trim() != '') {
              numberOfAnswers++
              for (let answerIndexInner in question.answers) {
                let answerInner = question.answers[answerIndexInner]
                if (
                  answerIndexInner != answerIndex &&
                  answer.label == answerInner.label
                ) {
                  if (answerMessage == '') {
                    answerMessage =
                      this.$t('alerts.optionsDuplicate') + '<br />'
                  }
                }
              }
            } else if (answerIndex != question.answers.length - 1) {
              this.errorTabs.push('voters')
              answerEmptyMessage = this.$t('alerts.optionEmpty') + '<br />'
            }
          }
          if (numberOfAnswers < 2) {
            if (hasEnoughAnswersMessage.trim() == '') {
              this.errorTabs.push('voters')
              hasEnoughAnswersMessage =
                this.$t('alerts.notEnoughOptions') + '<br />'
            }
          }
          if (question.multiple_choices_enabled) {
            if (question.max_choices > numberOfAnswers) {
              this.errorTabs.push('voters')
              answerLimitMessageMax =
                this.$t('alerts.tooManyOptionsMax') + '<br />'
            }
            if (question.min_choices >= numberOfAnswers) {
              this.errorTabs.push('voters')
              answerLimitMessageMin =
                this.$t('alerts.tooManyOptionsMin') + '<br />'
            }
            if (question.max_choices == 0) {
              this.errorTabs.push('voters')
              answerMaxZero = this.$t('alerts.maxZero') + '<br />'
            }
            if (question.min_choices == 0) {
              this.errorTabs.push('voters')
              answerMinZero = this.$t('alerts.minZero') + '<br />'
            }
          }
        }

        message += questionEmptyMessage
        message += questionMessage
        message += answerMessage
        message += answerEmptyMessage
        message += hasEnoughAnswersMessage
        message += answerLimitMessageMax
        message += answerLimitMessageMin
        message += answerMaxZero
        message += answerMinZero

        if (publish && this.event.sms_authentication) {
          let smsTerm = true
          for (let voter of this.event.voters) {
            if (voter.mobile.trim() == '') {
              smsTerm = false
            }
          }
          if (!smsTerm) {
            this.errorTabs.push('ballot')
            message += this.$t('alerts.eventSmsFail') + '<br />'
          }
        }

        if (this.editable) {
          if (this.event.status == 'active') {
            message += this.$t('alerts.eventStatusFail') + '<br />'
          }
          if (this.event.status == 'completed') {
            message += this.$t('alerts.eventStatusFail') + '<br />'
          }
        }
      }
      if (message == '') {
        if (publish) {
          this.event.status = 'published'
        }

        this.$APICall(
          'post',
          'EVENTS',
          '',
          this.event,
          () => {
            if (resendVoter != null) {
              this.$APICall(
                'post',
                'EVENTS',
                '/resend/' + this.event.id + '/voter/' + resendVoter,
                {},
                () => {
                  this.voterSendEmailLock = false
                  this.loadEvent()
                },
                true,
                error => {
                  handle_session_error(
                    error,
                    this.$store,
                    this.$router,
                    this.$prompt
                  )
                }
              )
            } else if (back) {
              this.justSaved = true

              this.$router.go(-1)
            } else {
              this.loadEvent()
            }
          },
          loader,
          error => {
            handle_session_error(error, this.$store, this.$router, this.$prompt)
          }
        )
      } else {
        this.$alert(message)
      }
    },

    eventSaveClick() {
      this.eventSave(true, null, false, true)
    },

    checkFieldError(fieldID) {
      return this.errorFields.indexOf(fieldID) !== -1
    },

    checkTabError(tabID) {
      return this.errorTabs.indexOf(tabID) !== -1
    },

    oldEventLoadDialogReset(destination) {
      this.oldEventLoadDialog = {
        show: false,
        destination: destination,
        event_id: null,
      }
    },

    oldEventLoadDialogClose() {
      this.oldEventLoadDialogReset()
    },

    oldEventLoadDialogSave() {
      let message = ''
      if (this.oldEventLoadDialog.event_id == null) {
        message += this.$t('alerts.eventMissing') + '<br />'
      }
      if (message == '') {
        let vm = this
        this.$APICall(
          'get',
          'EVENTS',
          '/' + this.oldEventLoadDialog.event_id,
          {},
          function (data) {
            if (vm.oldEventLoadDialog.destination == 'voters') {
              if (data.voters.length == 0) {
                vm.$alert(vm.$t('alerts.eventNoVoters'))
              }
              let imported = 0
              let total = 0
              let emailDomain = 0
              let duplicates = 0
              let emailDomainVoters = []
              let duplicatesVoters = []
              for (let voter of data.voters) {
                if (voter.active) {
                  total++
                  let newVoter = {
                    id: 0,
                    name: voter.name,
                    surname: voter.surname,
                    email: voter.email,
                    mobile: voter.mobile,
                    tags: voter.tags,
                    weight: voter.weight,
                    active: true,
                    authorizers: voter.authorizers.map(authorizer => {
                      authorizer.id = uuidv4()
                      return authorizer
                    }),
                  }
                  let term = true
                  for (let voterTemp of vm.event.voters) {
                    if (voterTemp.active) {
                      let duplicated = false
                      if (newVoter.email == voterTemp.email) {
                        term = false
                        duplicates++
                        duplicated = true
                        duplicatesVoters.push(newVoter)
                      }
                      if (
                        newVoter.mobile != '' &&
                        newVoter.mobile == voterTemp.mobile
                      ) {
                        term = false
                        if (!duplicated) {
                          duplicates++
                          duplicated = true
                          duplicatesVoters.push(newVoter)
                        }
                      }
                    }
                  }
                  if (!vm.checkEmailDomain(newVoter.email)) {
                    emailDomain++
                    term = false
                    emailDomainVoters.push(newVoter)
                    term = false
                  }
                  if (term) {
                    imported++
                    vm.event.voters.push(newVoter)
                  }
                }
              }
              let message =
                vm.$t('importLabels.totalRecords') + total + '<br />'
              message +=
                vm.$t('importLabels.importedRecords') + imported + '<br />'
              if (emailDomain != 0) {
                message +=
                  '<br />' +
                  vm.$t('importLabels.domainEmail') +
                  emailDomain +
                  '<br /><table style="width: 100%;">'
                for (let voter of emailDomainVoters) {
                  message +=
                    '<tr><td>' +
                    voter.name +
                    '</td><td>' +
                    voter.surname +
                    '</td><td>' +
                    voter.email +
                    '</td><td>' +
                    voter.mobile +
                    '<br />'
                }
                message += '</table>'
              }
              if (duplicates != 0) {
                message +=
                  '<br />' +
                  vm.$t('importLabels.duplicates') +
                  duplicates +
                  '<br /><table style="width: 100%;">'
                for (let voter of duplicatesVoters) {
                  message +=
                    '<tr><td>' +
                    voter.name +
                    '</td><td>' +
                    voter.surname +
                    '</td><td>' +
                    voter.email +
                    '</td><td>' +
                    voter.mobile +
                    '<br />'
                }
                message += '</table>'
              }
              vm.$alert(message)
            }
            if (vm.oldEventLoadDialog.destination == 'messages1') {
              vm.event.intro_mail = data.intro_mail
              vm.event.help_contact = data.help_contact
              vm.event.intro_mail_title = data.intro_mail_title
            }
            if (vm.oldEventLoadDialog.destination == 'messages2') {
              vm.event.reminder_mail = data.reminder_mail
              vm.event.reminder_mail_title = data.reminder_mail_title
            }
            if (vm.oldEventLoadDialog.destination == 'ballot') {
              vm.event.header = data.header
              vm.event.footer = data.footer
              vm.event.title = data.title

              vm.event.questions = data.questions.map(question => {
                // Map answers to Answer model.
                question.asnwers = question.answers.map(answer => {
                  return new Answer(answer)
                })

                question.started_at = null
                question.stopped_at = null

                // Map questions to Question mode.
                return new Question(question)
              })
            }
            vm.oldEventLoadDialogClose()
          },
          true,
          error => {
            handle_session_error(error, this.$store, this.$router, this.$prompt)
          }
        )
      } else {
        this.$alert(message)
      }
    },

    updateLanguageStrings() {
      let introAfterNoSms = this.$br2nl(
        this.translations[this.event.language].emailTexts.nonSmsExplanation
      )
      let introAfterSms = this.$br2nl(
        this.translations[this.event.language].emailTexts.smsExplanation
          .split('{last_digits}')
          .join('')
      )
      this.introAfter = this.event.sms_authentication
        ? introAfterSms
        : introAfterNoSms
    },

    checkEmailDomain(email) {
      if (!this.event.allow_all_domains && this.event.domains.length > 0) {
        let emailArray = email.split('@')
        let emailDomain = emailArray[emailArray.length - 1]
        let term = false
        for (let domain of this.event.domains) {
          if (domain.trim() == emailDomain) {
            term = true
          }
        }
        return term
      }
      return true
    },

    async startMeetingSession() {
      if (this.meetingSession !== null) {
        return
      }

      const logger = new ConsoleLogger('MyLogger', amazonChimeLogLevel)
      const deviceController = new DefaultDeviceController(logger)

      const configuration = new MeetingSessionConfiguration(
        { Meeting: this.event.meetingResponse.Meeting },
        { Attendee: this.event.attendeeResponse.Attendee }
      )

      this.meetingSession = new DefaultMeetingSession(
        configuration,
        logger,
        deviceController
      )

      const audioInputDevices = await this.meetingSession.audioVideo.listAudioInputDevices()
      await this.meetingSession.audioVideo.chooseAudioInputDevice(
        audioInputDevices[0]
      )

      const audioOutputDevices = await this.meetingSession.audioVideo.listAudioOutputDevices()
      await this.meetingSession.audioVideo.chooseAudioOutputDevice(
        audioOutputDevices[0]
      )

      this.meetingSession.audioVideo.bindAudioElement(
        document.getElementById('amazon-chime-audio')
      )

      this.meetingSession.audioVideo.addContentShareObserver(
        this.meetingObserver()
      )
      this.meetingSession.audioVideo.addObserver(this.meetingObserver())

      // Start listening audio.
      this.meetingSession.audioVideo.start()

      // Mute by default.
      this.meetingSession.audioVideo.realtimeMuteLocalAudio()
    },

    meetingObserver() {
      return {
        audioVideoDidStop: () => {
          this.stopMeetingSession()
        },

        contentShareDidStart: () => {
          this.screenSharingStarted = true
        },

        contentShareDidStop: () => {
          // Chime SDK allows 2 simultaneous content shares per meeting.
          // This method will be invoked if two attendees are already sharing content
          // when you call startContentShareFromScreenCapture or startContentShare.
          this.screenSharingStarted = false
        },

        videoTileWasRemoved: () => {
          this.numberOfScreensShared--
        },

        videoTileDidUpdate: tileState => {
          // Ignore a tile without attendee ID and videos.
          if (!tileState.boundAttendeeId || !tileState.isContent) {
            return
          }

          this.numberOfScreensShared++
        },
      }
    },

    // A browser will prompt the user to choose the screen.
    async startScreenSharing() {
      try {
        await this.meetingSession.audioVideo.startContentShareFromScreenCapture()
      } catch (e) {
        // This gets called when the user wants to start screen sharing, but then decides not to.
        // It is best to ignore this error, and not let it log errors in the console.
      }
    },

    async stopScreenSharing() {
      await this.meetingSession.audioVideo.stopContentShare()
    },

    loadEvent(refreshNotify = false) {
      let vm = this
      this.$APICall(
        'get',
        'EVENTS',
        '/' + this.event.id,
        {},
        function (data) {
          if (data.status == 'draft') {
            vm.editable = true
          } else {
            vm.editable = false
          }
          vm.event = data
          vm.moduleTitle = data.name

          if (vm.event.status === 'active') {
            vm.bindPusherChannels()

            vm.voters_online = vm.event.voters_online
            vm.voters_online_list = vm.event.voters_online_list

            if (
              vm.event.voter_ui_type === VOTER_UI_TYPE_ADVANCED &&
              vm.event.enable_audio_video == true
            ) {
              vm.startMeetingSession()
            }
          } else {
            vm.stopMeetingSession()
          }

          // Map logo to Logo model.
          if (vm.event.logo !== null) {
            vm.event.logo = new Logo(vm.event.logo)
          }

          // Map questions to Question model.
          vm.event.questions = vm.event.questions.map(question => {
            return new Question(question)
          })

          // Map documents to Document model.
          vm.event.documents = vm.event.documents.map(document => {
            return new Document(document)
          })

          // Map messages to Message model.
          vm.event.messages = vm.event.messages.map(message => {
            if (message.seen === false) {
              vm.new_message_indicator = true
            }
            return new Message(message)
          })

          // Map voters to Voter model.
          vm.event.voters = vm.event.voters.map(voter0 => {
            const voter = new Voter(voter0)

            // Map authorizers to Authorizer model.
            voter.authorizers = voter.authorizers.map(
              authorizer => new Authorizer(authorizer)
            )

            return voter
          })

          if (vm.editable) {
            // Adds empty answer to each question because there needs to be a empty last answer to add more.
            vm.event.questions.forEach(question => {
              question.addBlankAnswer()
            })
          }

          for (let question in vm.event.votes) {
            let votes = vm.event.votes[question]
            let max = 0
            for (let answer in votes) {
              let score = votes[answer]
              if (parseInt(score) > max) {
                max = parseInt(score)
              }
            }
            let questionChart = {}
            let colorIndex = -1
            for (let answer in votes) {
              colorIndex++
              let color = ''
              if (colorIndex >= vm.$resultColors.length) {
                colorIndex = 0
              }
              color = vm.$resultColors[colorIndex]
              let score = votes[answer]
              let percentage = (score / max) * 100
              questionChart[answer] = {
                score: percentage,
                color: color,
              }
            }
            vm.charts[question] = questionChart
          }
          vm.$nextTick(() => {
            vm.loaded = true
          })
          if (refreshNotify) {
            vm.$notify(vm.$t('alerts.pageRefreshed'))
          }
        },
        true,
        error => {
          handle_session_error(error, this.$store, this.$router, this.$prompt)
        }
      )
    },

    initializeComponent() {
      this.$APICall(
        'get',
        'SELECT',
        '/events/' + this.event.id,
        [],
        data => {
          this.numberOfOtherEvents = data.otherEvents.length
        },
        true,
        error => {
          handle_session_error(error, this.$store, this.$router, this.$prompt)
        }
      )

      this.event.id = this.$route.params.id

      if (this.event.id != 0) {
        this.loadEvent()
      } else {
        this.moduleTitle = this.$t('modules.newEvent')
        this.loaded = true
      }
    },
    showOnlineVoters() {
      this.displayOnlineVotersList = true
    },
    closeOnlineVotersList() {
      this.displayOnlineVotersList = false
    },
  },

  mounted() {
    this.$APICall(
      'get',
      'TRANSLATIONS',
      '',
      {},
      data => {
        this.translations = data
        this.updateLanguageStrings()
        this.initializeComponent()
      },
      true,
      error => {
        handle_session_error(error, this.$store, this.$router, this.$prompt)
      }
    )
  },

  beforeRouteLeave(to, from, next) {
    if (
      this.editable &&
      to.name != 'Dashboard' &&
      this.$store.getters.isAuthenticated
    ) {
      if (!this.justSaved) {
        this.$verify(this.$t('alerts.leaveQuestion'), result => {
          next(result)
        })
      } else {
        next(true)
      }
    } else {
      next(true)
    }
  },
}
</script>

<style scoped>
::v-deep .main-event-tabs .v-tabs__container {
  border-bottom: 2px solid #e8e8e8;
  height: 80px !important;
  background: transparent !important;
}

::v-deep .main-event-tabs .v-tabs__bar {
  background: transparent !important;
}

::v-deep .main-event-tabs .v-tabs__slider {
  height: 4px !important;
  margin-bottom: -1px !important;
}

::v-deep .main-event-tabs .v-tabs__item {
  color: #acacac !important;
}

::v-deep .main-event-tabs .v-tabs__item i {
  color: #acacac !important;
}

::v-deep .main-event-tabs .v-tabs__item .error-icon {
  color: #ff0000 !important;
}

::v-deep .main-event-tabs .v-tabs__item--active {
  color: #6f6f6f !important;
}

::v-deep .main-event-tabs .v-tabs__item--active i {
  color: #92be54 !important;
}

::v-deep .main-event-tabs .v-tabs__item--active .error-icon {
  color: #ff0000 !important;
}

::v-deep .event-main-card {
  background: transparent !important;
}

::v-deep .error--text > .v-input__control > .v-input__slot {
  border: 2px solid #ff0000 !important;
}
</style>
